
import {Component} from '@angular/core';

@Component({
    selector: 'snack-bar-component-copy',
    templateUrl: 'copy.snack.component.html',
    styles: [`
      .copy-snack {
        color: rgb(187, 236, 255);
        text-align: center;
        bottom:8px;
        padding-left:25%;
      }
    `],
  })
  export class SnackMessageComponent {}